import React from 'react'
import './button.css'
import '../css/clickable.css'

const Button = (props) => {

  const onClick = (event) => {
    event.stopPropagation()
    if (props.action && !props.disabled) {
      props.action(event)
    }
  }

  const shape = props.label ? '' : 'fab'
  const pose = props.raised ? 'raised' : 'flat'
  let theme = props.primary ? 'primary' : ''
  theme = props.secondary ? 'secondary' : theme
  theme = props.accent ? 'accent' : theme
  const disabled = props.disabled ? 'disabled' : 'clickable'
  const icon = props.icon ? <span className="btn-icon material-icons">{props.icon}</span> : ''
  const badge = props.badge ? <div className="badge">{props.badge}</div> : ''

  return (
    <button className={`button ${shape} ${pose} ${theme} ${disabled} ${props.className}`} onClick={onClick}>
      {icon}
      <span className="label">{props.label}</span>
      {badge}
    </button>
  )
}

const FileButton = (props) => {

  const accept = ((accept) => {
    switch(accept) {
      case "PDF":
        return "application/pdf"
      case "IMAGE":
        return "image/*;capture=camera"
      default:
        return "image/*;capture=camera"
    }
  })(props.accept)

  const icon = props.icon ? props.icon : "add_a_photo"

  return (
    <label htmlFor="file" className={`fileButton icon clickable ${props.className}`}>
      <i className="material-icons clickable">{icon}</i>
      <input
        id="file"
        type="file"
        accept={accept}
        onChange={props.onChange}
        className="inputfile"
      />
    </label>
  )
}

export { Button, FileButton }



// WEBPACK FOOTER //
// ./src/lib/components/button.js